import type { CSSProperties } from 'react'

export const BOX_COMPARE_AT_PRICE_CLASS = 'font-semibold text-red-600 line-through decoration-2 decoration-red-600/90'
export const BOX_CURRENT_PRICE_CLASS = 'font-extrabold text-green-700'

const BOX_CURRENT_PRICE_COLOR = '#15803d'

export const resolveBoxCurrentPriceStyle = (
  baseStyle: CSSProperties | undefined,
  isBox: boolean,
): CSSProperties | undefined => (
  isBox
    ? { ...baseStyle, color: BOX_CURRENT_PRICE_COLOR, fontWeight: 800 }
    : baseStyle
)
